import React from 'react';
import Loader from 'react-loader-spinner'
//Components

//Styles
import Styles from './SubmitButton.module.scss';

//Utils
import PropTypes from 'prop-types';

const SubmitButton = ({propsClass, submitHandler, isLoading, children, disabled, ...props}) => {

    return (
        <button disabled={disabled} className={[Styles.button, propsClass ].join(' ')} onClick={submitHandler} {...props}>
            {
                isLoading  ?
                <Loader type="TailSpin" color="#fff" height={35} width={35}/> :
                children
            }
        </button>
    );
};

SubmitButton.propTypes = {
    isLoading: PropTypes.bool,
    submitHandler: PropTypes.func,
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool
};

export default SubmitButton
